// Stripes TextField types don't accept standard HTML values for `type` ("password") and
// `autoComplete` ("new-password") — cast until fixed upstream. The runtime values are the
// real HTML ones, so the rendered input is a proper password field.
export var PASSWORD_INPUT_TYPE = "password";
export var NEW_PASSWORD_AUTOCOMPLETE = "new-password";
// Stripes TextField's types allow `inputRef` only as a RefObject, but at runtime it takes a
// callback ref too (TextField.js wraps a function `inputRef` and calls it with the <input>).
// react-hook-form's field ref is such a callback; passed as `ref` it would get the class
// instance, which has no focus() (CZNA-1591, see SetPasswordModal).
export var asTextFieldInputRef = function (ref) {
    return ref;
};
